/**
 * Check if the user can participate to the event
 */
export function getRouteNameFromSection(section) {
    if (section === 'section-2') {
        return "neighbourhood.activities.activity-stream";
    }
    if (section === 'section-3') {
        return "community.activities.activity-stream";
    }
    if (section === 'section-4') {
        return "membership.activities.activity-stream";
    }
    return "activities.activity-stream";
}
